/**
 * @generated SignedSource<<38399c3f066dc919e4fe0caffea1cbc5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductDetailsRowNumber$data = {
  readonly label: string;
  readonly number: number | null;
  readonly subTitle: string | null;
  readonly " $fragmentType": "ProductDetailsRowNumber";
};
export type ProductDetailsRowNumber$key = {
  readonly " $data"?: ProductDetailsRowNumber$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductDetailsRowNumber">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductDetailsRowNumber",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "number",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "label",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "subTitle",
      "storageKey": null
    }
  ],
  "type": "ProductInfoComponentNumberRow",
  "abstractKey": null
};

(node as any).hash = "e01d405e34d4bec067f80cccc28e3555";

export default node;
